export default __webpack_public_path__ + "static/media/Icon_Grid.165d7549.svg";